import React, { useState, useEffect } from 'react';
import {
  Typography,
  Button,
  TextField,
  Box,
} from '@mui/material';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const DEFAULT_ROBOTS = `User-agent: *
Disallow: /`;

const RobotsTxtEditor = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [robotsTxt, setRobotsTxt] = useState(DEFAULT_ROBOTS);

  useEffect(() => {
    const r = settings.custom?.robotsTxt;
    if (r && r.content !== undefined) setRobotsTxt(r.content);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleInputChange = (event) => {
    setRobotsTxt(event.target.value);
  };

  const handleReset = () => {
    setRobotsTxt(DEFAULT_ROBOTS);
  };

  const handleSubmit = async () => {
    try {
      await updateSettings({
        custom: { robotsTxt: { content: robotsTxt } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Robots.txt Editor</Typography>
      <Typography variant="body1" color="textSecondary">
        Control search engine crawlers' access to specific pages on a website.
      </Typography>
      <Box sx={{ mt: 2 }}>
        <TextField
          multiline
          rows={8}
          fullWidth
          value={robotsTxt}
          onChange={handleInputChange}
          variant="outlined"
          label="Enter robots.txt content"
        />
      </Box>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" onClick={handleReset}>
          Reset
        </Button>
        <Button variant="contained" color="primary" sx={{ ml: 2 }} onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Submit'}
        </Button>
      </Box>

      <SaveSnackbar snack={snack} onClose={closeSnack} />
    </Box>
  );
};

export default RobotsTxtEditor;
